import { ConnectLoginDataType, UseAuthResult } from './useConnectAuth.types';

const generateRandomString = (): string => {
  const length = Math.floor(Math.random() * 6) + 15;
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';

  for (let i = 0; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }

  return result;
};

export const useConnectAuth = (): UseAuthResult => {
  const loginLink = `${window.env.WOAD_CONNECT_URL}`;

  const startConnectLogin = () => {
    const redirect = `${window.location.origin}/`;
    const state = generateRandomString();
    const nonce = generateRandomString();

    localStorage.setItem('connect_data', JSON.stringify({ state, nonce }));
    window.location.href = `${loginLink}&redirect_uri=${redirect}&state=${state}&nonce=${nonce}`;
  };

  const getConnectLoginData = (): ConnectLoginDataType | null => {
    const data = localStorage.getItem('connect_data');
    localStorage.removeItem('connect_data');

    if (!data) return null;

    return JSON.parse(data);
  };

  return { startConnectLogin, getConnectLoginData };
};

export default useConnectAuth;
